<template>
  <div class="shipping-page py-3">
    <header class="shipping-toolbar">
      <span class="shipping-toolbar__accent" aria-hidden="true"></span>
      <div>
        <h1>Shipping &amp; COD</h1>
        <p>Configure the flat fee added when a customer chooses Cash on Delivery</p>
      </div>
    </header>

    <CAlert v-if="errorMessage" color="danger" show class="shipping-alert">{{ errorMessage }}</CAlert>
    <CAlert v-if="successMessage" color="success" show class="shipping-alert">{{ successMessage }}</CAlert>

    <section class="shipping-card">
      <header class="shipping-card__head">
        <h2>COD Fee</h2>
        <p>Added to the shipping charge of any order whose payment method is COD</p>
      </header>
      <div class="shipping-card__body">
        <div class="shipping-field">
          <label class="shipping-label" for="cod_fee">COD Fee (₹)</label>
          <input
            id="cod_fee"
            :value="codFee"
            type="number"
            min="0"
            step="1"
            inputmode="numeric"
            class="shipping-input"
            :disabled="isLoading || isSaving"
            @input="codFee = $event.target.value"
          />
        </div>
        <div class="shipping-actions">
          <CButton color="primary" :disabled="isLoading || isSaving || !isValid" @click="saveCodFee">
            {{ isSaving ? 'Saving…' : 'Save' }}
          </CButton>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SettingsShipping',
  data () {
    return {
      codFee: 0,
      isLoading: false,
      isSaving: false,
      errorMessage: '',
      successMessage: ''
    }
  },
  computed: {
    isValid () {
      const n = Number(this.codFee)
      return Number.isFinite(n) && n >= 0
    }
  },
  created () {
    this.loadCodFee()
  },
  methods: {
    loadCodFee () {
      this.isLoading = true
      this.errorMessage = ''
      axios.get(`${this.$apiAdress}/api/settings/cod-fee`)
        .then((response) => {
          this.codFee = Number(response.data?.cod_fee || 0)
        })
        .catch((error) => {
          this.errorMessage = error?.response?.data?.message || 'Unable to load COD fee.'
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveCodFee () {
      this.isSaving = true
      this.errorMessage = ''
      this.successMessage = ''
      axios.put(`${this.$apiAdress}/api/settings/cod-fee`, { cod_fee: Number(this.codFee) })
        .then((response) => {
          this.codFee = Number(response.data?.cod_fee || 0)
          this.successMessage = 'COD fee updated.'
          setTimeout(() => { this.successMessage = '' }, 2500)
        })
        .catch((error) => {
          this.errorMessage = error?.response?.data?.message || 'Unable to update COD fee.'
        })
        .finally(() => {
          this.isSaving = false
        })
    }
  }
}
</script>

<style scoped>
.shipping-page { padding: 0.25rem 0; }

.shipping-toolbar {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.25rem 0.25rem 1rem;
}

.shipping-toolbar__accent {
  width: 4px;
  height: 36px;
  border-radius: 4px;
  background: linear-gradient(180deg, #0e5b46 0%, #16a07a 100%);
  flex-shrink: 0;
}

.shipping-toolbar h1 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #1f2a44;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.shipping-toolbar p {
  margin: 0;
  font-size: 0.78rem;
  color: #6b7280;
}

.shipping-alert { margin: 0 0 1rem; }

.shipping-card {
  background: #ffffff;
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  max-width: 520px;
}

.shipping-card__head {
  padding: 0.85rem 1rem;
  background: #fbfcfe;
  border-bottom: 1px solid #eef1f7;
}

.shipping-card__head h2 {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 700;
  color: #1f2a44;
}

.shipping-card__head p {
  margin: 0.15rem 0 0;
  font-size: 0.78rem;
  color: #6b7280;
}

.shipping-card__body {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.shipping-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.shipping-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #4b5563;
}

.shipping-input {
  height: 38px;
  padding: 0 0.65rem;
  border: 1px solid #d8dde6;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #1f2a44;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.shipping-input:focus {
  border-color: #16a07a;
  box-shadow: 0 0 0 3px rgba(22, 160, 122, 0.18);
}

.shipping-actions {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 575px) {
  .shipping-page {
    padding: 0 0 0.5rem;
  }
  .shipping-toolbar {
    padding: 0.25rem 0 0.75rem;
    gap: 0.5rem;
  }
  .shipping-toolbar__accent {
    height: 30px;
  }
  .shipping-toolbar h1 {
    font-size: 1rem;
  }
  .shipping-toolbar p {
    font-size: 0.72rem;
  }
  .shipping-card {
    max-width: 100%;
    border-radius: 10px;
  }
  .shipping-card__body {
    padding: 0.75rem;
  }
  .shipping-actions {
    justify-content: stretch;
  }
  .shipping-actions >>> .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
